<template>
    <div
        v-if="isNoEmrAfterOperated && (this.surgeryInfo.enum_surgery_status == 40 || this.surgeryInfo.enum_surgery_status == 60)"
        style="margin: 0px 0; line-height: 600px; font-size: 30px; opacity: 0.5; text-align: center"
    >
        手术已结束或复苏结束,不允许查看!
    </div>
    <div v-else>
        <el-container v-wechat-title="title" :style="{ height: this.screenHeight - 115 + 'px', position: 'relative' }">
            <el-aside v-if="displayMode != 2" width="300px">
                <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                    <div style="padding: 5px 10px">
                        <el-input v-model="queryInput" placeholder="快速查找"></el-input>
                    </div>
                    <el-menu v-if="labTestList.length > 0" unique-opened :default-active="firstLabTestNo" @select="handleSelect">
                        <el-submenu v-for="date in labTestGroupDates" :index="date" :key="date" align="left">
                            <template slot="title">
                                <i class="el-icon-time"></i>
                                <span>{{ date }}</span>
                            </template>
                            <el-menu-item v-for="item in labTestGroup[date]" :index="item.test_no" :key="item.test_no">
                                <span style="color: red;">{{ item.testTag }}</span>
                                <span>{{ $moment(item.report_dt).format('HH:mm') }}</span>
                                <span class="ellipsis" :title="item.test_name">{{ item.test_name }}</span>
                            </el-menu-item>
                        </el-submenu>
                    </el-menu>
                    <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
                </el-scrollbar>
            </el-aside>
            <el-main class="width-p100" style="padding: 10px; margin-left: 10px; height: 100%; background: white" v-loading="loading">
                <div v-if="displayMode != 0 && currentLabTestRefUrl" style="text-align: left">
                    <el-link v-if="isCustomProtocol" :href="currentLabTestRefUrl" target="_blank" type="primary"><i class="el-icon-link"></i>报告详情</el-link>
                    <iframe v-else frameborder="0" scrolling="auto" :src="currentLabTestRefUrl" :height="this.screenHeight - 140" width="100%"></iframe>
                </div>
                <div v-else-if="currentLabTest">
                    <el-row v-if="lisconfig">
                        <el-col :span="24" class="align-right">
                            <el-button type="primary" size="mini" @click="tblistoAnes(lisconfig)">{{ lisconfig.BtnName }}</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <div class="report-no">检验单号#{{ currentLabTest.test_no }}</div>
                            <div class="report-title">
                                {{ currentLabTest.test_name }}<span class="report-subtitle">标本：{{ currentLabTest.specimen }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="report-request-dt">申请时间：{{ $moment(currentLabTest.request_dt).format('YYYY/MM/DD HH:mm') }}</div>
                            <div class="report-report-dt">报告时间：{{ $moment(currentLabTest.report_dt).format('YYYY/MM/DD HH:mm') }}</div>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <div class="report-content-container">
                        <el-table stripe :data="currentLabTestResults" :height="this.screenHeight - 225" style="width: 100%; border: 1px solid #e4e7ed">
                            <el-table-column label="项目名称">
                                <template slot-scope="scope">
                                    <span :class="{'el-icon-star-on':scope.row.is_follow ,'el-icon-star-off':!scope.row.is_follow}" style="margin-right:5px; cursor: pointer;color:orange;" @click="isFollow(scope.row.id,!scope.row.is_follow)"></span>
                                    <el-link @click="loadNoticeView(scope.row)">{{ scope.row.item_name }}</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column label="检验结果">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px" :style="{ color: scope.row.IsShowTag ? scope.row.TagColor : '' }">{{ scope.row.text_value }}</span>
                                    <span :style="{ color: scope.row.IsShowTag ? scope.row.TagColor : '' }" v-if="scope.row.IsShowTag">{{ scope.row.Tag }}</span>
                                    <!-- <i class="el-icon-top" v-if="scope.row.alert_flag == '1'"></i>
                                    <i class="el-icon-bottom" v-if="scope.row.alert_flag == '-1'"></i> -->
                                </template>
                            </el-table-column>
                            <el-table-column prop="unit" label="单位"> </el-table-column>
                            <el-table-column prop="normal_range" label="参考值范围"> </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5">
                    <span class="el-icon-document"></span>
                </div>
            </el-main>
            <el-dialog class="form-table-h380" :title="noticeView.title" :visible.sync="noticeView.dialogFormVisible" :close-on-click-modal="false" width="80%">
                <!-- <div style="margin: 15px"> -->

                <div>
                    <div style="text-align: left">单位:{{ noticeView.unit }}|参考值范围:{{ noticeView.normal_range }}</div>
                    <el-col :span="12">
                        <!-- <v-chart :options="option" style="width: 300px; height: 250px; top: -30px" /> -->
                        <v-chart :options="option" style="width: 900px; height: 350px; top: -20px" />
                    </el-col>
                </div>
            </el-dialog>
        </el-container>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ECharts from 'vue-echarts/components/ECharts'
export default {
    name: `Lis`,
    components: {
        'v-chart': ECharts
    },
    props: {},
    data() {
        return {
            title: `检验`,
            queryInput: ``,
            surgeryId: this.$route.query.surgery_id,
            record_type: this.$route.query.record_type,
            token: this.$route.query.token,
            labTestResultList: [],
            displayMode: this.$root.LabTestDisplayMode,
            refUrl: this.$root.LabTestRefUrl,
            loading: false,
            defaultConfig: null,
            currentLabTest: null,
            lisConfigList: this.$root.LisConfigList,
            surgeryInfo: {},
            visitInfo: {},
            noticeView: {
                dialogFormVisible: false,
                title: ``,
                data: [],
                dataX: [],
                dataY: []
            },
            isNoEmrAfterOperated: false
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`]),
        labTestList() {
            let labTestList = _.map(this.labTestResultList, labTestResult => {
                return _.pick(labTestResult, [`biz_surgery_info_id`, `test_no`, `test_name`, `specimen`, `request_dt`, `report_dt`])
            })
            let queryInput = this.queryInput
            labTestList = _.uniqBy(labTestList, `test_no`)
            labTestList = _.filter(labTestList, value => {
                if (value && value.test_name) {
                    return _.includes(value.test_name.toUpperCase(), queryInput.toUpperCase())
                }
            })
            let originalValues = _.map(this.defaultConfig, `OriginalValue`)
            _.each(labTestList, value => {
                let list = _.filter(this.labTestResultList, item => {
                    return item.test_no == value.test_no && _.indexOf(originalValues, item.alert_flag) >= 0
                })
                value.testTag = ``
                if (this.$root.IsLabtestShowTestFlag == `1` && list.length > 0) {
                    value.testTag = _.join(_.union(_.map(list, `alert_flag`)), ``)
                }
            })
            return _.orderBy(labTestList, `report_dt`, `desc`)
        },
        labTestGroup() {
            return _.groupBy(this.labTestList, value => {
                return this.$moment(value.report_dt).format(`YYYY/MM/DD`)
            })
        },
        labTestGroupDates() {
            let dates = _.keys(this.labTestGroup)
            dates = _.orderBy(dates, null, `desc`)
            return dates
        },
        firstLabTest() {
            return this.labTestGroupDates.length > 0 ? this.labTestGroup[this.labTestGroupDates[0]][0] : null
        },
        firstLabTestNo() {
            return this.firstLabTest && this.firstLabTest.test_no
        },
        currentLabTestResults() {
            _.each(this.labTestResultList, value => {
                var config = _.filter(this.defaultConfig, function(item) { return item.OriginalValue == value.alert_flag })
                if (config.length > 0) {
                    value.Tag = config[0].NewValue
                    value.TagColor = config[0].Color
                    value.IsShowTag = true
                } else { value.IsShowTag = false }
            })
            return _.filter(this.labTestResultList, value => {
                return value.test_no == this.currentLabTest.test_no
            })
        },
        currentLabTestRefUrl() {
            if (!this.refUrl) return null
            let refUrl = this.refUrl
            let jmType = ``
            if (refUrl.indexOf(`base64_utf8`) != -1) {
                jmType = `|base64_utf8`
            }
            if (this.currentLabTest) {
                refUrl = refUrl.replace(`@testNo` + jmType, jmType == `` ? this.currentLabTest.test_no : window.btoa(unescape(encodeURIComponent(this.currentLabTest.test_no))))
            }
            if (this.currentUser) {
                _.each(this.currentUser, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.visitInfo) {
                _.each(this.visitInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.surgeryInfo) {
                _.each(this.surgeryInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            return refUrl
        },
        isCustomProtocol() {
            return !_.startsWith(this.currentLabTestRefUrl, `http`)
        },
        option() {
            return {
                tooltip: {
                    trigger: `axis`,
                    formatter: function(params) {
                        return `值:${params[0].value}<br>
                        报告时间:${params[0].name}`
                    }
                },
                legend: {
                    data: []
                    // bottom:'left',
                    // top: `20`
                },
                color: [`#46629D`, `#3db5ba`],
                xAxis: {
                    type: `category`,
                    axisLine: {
                        lineStyle: {
                            color: `#A9A9A9` // 坐标轴的颜色
                        }
                    },
                    boundaryGap: true,
                    name: `报告时间`,
                    data: this.noticeView.dataX
                    // data: [`2021/06/13 10:45`, `2021/06/17 10:45`, `2021/06/22 10:50`, `2021/06/23 12:50`, `2021/06/24 14:10`, `2021/06/25 14:10`, `2021/06/26 14:10`, `2021/06/29 10:55`]
                },
                yAxis: {
                    type: `value`,
                    name: `检验值`,
                    axisLine: {
                        lineStyle: {
                            color: `#A9A9A9` // 坐标轴的颜色
                        }
                    }
                },
                series: [
                    {
                        data: this.noticeView.dataY,
                        // data: [68.9, 70.9, 69.4, 68.5, 69.5],
                        type: `line`,
                        symbol: `circle`, // 是否显示实心的折线圆点
                        smooth: true, // 让折线有弧度
                        symbolSize: 7, // 折线圆点的大小
                        itemStyle: {
                            normal: {
                                color: `#7CB5EC`, // 折线点的颜色
                                lineStyle: {
                                    color: `#7CB5EC` // 折线的颜色
                                },
                                label: { show: true } // 是否在折线点上显示数字
                            }
                        }
                    }
                ]
            }
        },
        lisconfig() {
            if (this.lisConfigList != `` && this.lisConfigList != undefined) {
                let t = eval(
                    `(` + this.lisConfigList + `)`
                )
                if (t != null) {
                    let r = _.find(t, d => {
                        return d.TestName == this.currentLabTest.test_name
                    })
                    return r
                }
            }
            return null
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.isNoEmrAfterOperated = this.$root.IsNoEmrAfterOperated == `1`
    },
    mounted() {
        this.loadConfigSetting()
        this.loadSurgery()
        this.loadLabTestResult()
    },
    methods: {
        isFollow(id, isfollow) {
            let req = this.myaxios.put(`/api/Nursing/LabTestResult/PutFollow?id=${id}&isFollow=${isfollow}`)
            req.then(data => {
                this.loadLabTestResult()
            }).catch(e => {
            })
        },
        loadConfigSetting() {
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=LabtestAlertFlagConfig`) // 获取参数信息
            req.then(data => {
                if (data) {
                    var configJson = JSON.parse(data.value)
                    that.defaultConfig = configJson
                }
            }).catch(e => {
            })
        },
        isjson(jsonstr) {
            if (typeof jsonstr == `string`) {
                try {
                    var obj = JSON.parse(jsonstr)
                    if (typeof obj == `object` && obj) {
                        return true
                    } else {
                        return false
                    }
                } catch (e) {
                    return false
                }
            }
            return false
        },
        loadSurgery() {
            if (!this.surgeryId) {
                this.surgeryInfo = {}
                this.visitInfo = {}
                return
            }
            var that = this
            this.myaxios
                .get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                .then(data => {
                    let extrDatas = _.reduce(data.extra_datas, function(result, value, index) {
                        let flag = that.isjson(value.DataValue)
                        if (value.DataValue != `` && flag == true) {
                            result[value.DataKey] = value.DataExtraValue
                        } else {
                            result[value.DataKey] = value.DataValue
                        }
                        return result
                    }, {})
                    this.surgeryInfo = Object.assign(data, extrDatas)
                    this.visitInfo = data.visit_info
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadLabTestResult() {
            if (!this.surgeryId) {
                this.labTestResultList = []
                return
            }
            this.myaxios
                .get(`/api/Nursing/LabTestResult/Get?surgeryId=${this.surgeryId}`)
                .then(data => {
                    this.labTestResultList = data
                })
                .catch(e => {
                    console.log(e)
                })
        },
        handleSelect(index) {
            let currentLabTest = _.find(this.labTestList, {
                test_no: index
            })
            if (currentLabTest) this.currentLabTest = currentLabTest
        },
        loadNoticeView(row) {
            let samecheckItems = _.filter(this.labTestResultList, { item_code: row.item_code })
            let tmpsamecheckItems = _.orderBy(samecheckItems, `report_dt`, `asc`)
            this.noticeView.dataX = []
            this.noticeView.dataY = []
            _.forEach(tmpsamecheckItems, b => {
                let d = this.$moment(b.report_dt).format(`MM/DD hh:mm`)
                this.noticeView.dataX.push(d)
                this.noticeView.dataY.push(b.text_value)
            })
            this.noticeView.title = `${row.item_name}(${row.item_code})`
            this.noticeView.unit = row.unit
            this.noticeView.normal_range = row.normal_range
            this.noticeView.dialogFormVisible = true
        },
        tblistoAnes(config) {
            console.log(111)
            console.log(config)
            let that = this
            let recordtype = that.record_type == undefined ? 0 : that.record_type
            this.$confirm(config.TipMsg, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.get(`/api/Nursing/LabTestResult/LabTestToAnes?surgeryId=${that.surgeryId}&recordtype=${recordtype}&test_no=${this.currentLabTest.test_no}`)
                req.then(data => {
                    that.$message.success(config.SuccessMsg)
                    that.loadLabTestResult()
                }).catch(e => {
                })
            }).catch(e => { })
        }
    },
    watch: {
        firstLabTest(value) {
            this.currentLabTest = value
        },
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadSurgery()
            this.loadLabTestResult()
        }
    }
}
</script>
<style scoped lang="less">
.report-content-container {
    margin-top: 15px;
}
.report-no {
    padding-top: 5px;
    text-align: left;
    font-size: 14px;
    color: #909399;
}
.report-title {
    text-align: left;
    font-size: 24px;
    color: #303133;
    font-weight: bold;
    padding-top: 5px;

    .report-subtitle {
        text-align: left;
        font-size: 14px;
        color: #909399;
        font-weight: normal;
        padding-left: 10px;
    }
}
.report-request-dt,
.report-report-dt {
    padding-top: 10px;
    text-align: right;
    font-size: 14px;
    color: #909399;
}
.ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Lis/Index.vue